<template>
<div class="chapter">
<div class="inner_page">
<div id="fm4">
<p class="title">Sarah Thornhill</p>
<p class="title1">KATE</p>
<p class="title2">GRENNVILLE</p>
<p class="image">
<img alt="" src="images/img_0001.jpg"/></p>
<p class="title3">TEXT PUBLISHING MELBOURNE AUSTRALIA</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?174240f6